import React from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAchatsConfig } from './useAchatsConfig';

const DelaisLeadTimePage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.achats.pages.delaisLeadTimePage.${key}`, opts);
  const achatsConfig = useAchatsConfig();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Clock className="h-8 w-8 text-green-400" />
            <h1 className="text-3xl font-bold text-white">{p('title')}</h1>
          </div>
          <p className="text-white/60">{p('subtitle')}</p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-12 text-center">
          <div className="inline-block p-6 bg-green-500/10 rounded-full mb-6">
            <Clock className="h-16 w-16 text-green-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">{p('card_title')}</h2>
          <p className="text-white/60 text-lg mb-6">
            {p('card_description')}
          </p>
          <p className="text-white/80 text-base mb-6">
            {p('default_lead_time_label', { defaultValue: 'مدة التوريد الافتراضية من الإعدادات' })}:{' '}
            <span className="font-semibold text-green-300">{achatsConfig.defaultLeadTimeDays}</span>{' '}
            {p('days_suffix', { defaultValue: 'يوم' })}
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-green-500/20 border border-green-400/30 rounded-xl text-green-300">
            <span className="animate-pulse">●</span>
            <span>{p('module_in_development')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelaisLeadTimePage;
